module.exports = __webpack_public_path__ + "img/40_69_015_100.34a5ee10.jpg";